import type { Routes } from '@angular/router';

export const STORIES_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/posts/views/stories-root/stories-root.component').then((m) => m.StoriesRootComponent),
    },
];
